import type { StackProps } from '@mui/material';
import { Stack, Typography } from '@mui/material';
import type { TypographyOwnProps } from '@mui/material/Typography/Typography';

type InfoSectionProps = StackProps & {
  title: string;
  infoIcon?: React.ReactNode;
  titleVariant?: TypographyOwnProps['variant'];
};

export const InfoSection = (props: InfoSectionProps) => {
  const { title, infoIcon, children, titleVariant = 'Body/Bold/large', ...restProps } = props;

  return (
    <Stack spacing={2} {...restProps}>
      <Stack direction="row" spacing={0.5} alignItems="center">
        <Typography variant={titleVariant}>{title}</Typography>
        {infoIcon && infoIcon}
      </Stack>
      {children}
    </Stack>
  );
};
